module.exports = __webpack_public_path__ + "img/map-chile.3c6d1117.jpg";